import { Phone } from "lucide-react";
import { CLINIC } from "@/lib/api";

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
    <path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4c-1-1.6-1.5-3.4-1.5-5.2 0-5.4 4.4-9.8 9.8-9.8 2.6 0 5.1 1 6.9 2.9 1.8 1.8 2.9 4.3 2.9 6.9 0 5.4-4.4 9.8-9.8 9.8zM20.5 3.5C18.2 1.2 15.2 0 12 0 5.4 0 .1 5.3.1 11.9c0 2.1.6 4.2 1.6 6L0 24l6.3-1.6c1.8 1 3.8 1.5 5.7 1.5 6.6 0 11.9-5.3 11.9-11.9 0-3.2-1.2-6.2-3.4-8.5z" />
  </svg>
);

export const FloatingButtons = ({ hideOnMobile = false }) => (
  <div className={`fixed bottom-24 right-5 z-40 flex-col gap-3 ${hideOnMobile ? "hidden sm:flex" : "flex"}`}>
    <a href={CLINIC.whatsapp} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-button" aria-label="Chat on WhatsApp"
      className="btn-pop flex h-12 w-12 items-center justify-center rounded-full bg-[#25d366] text-white shadow-lg ring-4 ring-white">
      <WhatsAppIcon />
    </a>
    <a href={`tel:${CLINIC.phoneRaw}`} data-testid="floating-call-button" aria-label="Call the clinic"
      className="btn-pop flex h-12 w-12 items-center justify-center rounded-full bg-[#38bdf8] text-white shadow-lg ring-4 ring-white">
      <Phone className="h-5 w-5" />
    </a>
  </div>
);
